import { gql } from "@apollo/client";

import { NoticeID } from "components/common/composite/HeadingWithNotice";
import { Account, Counts, UiFlags, User } from "graphql/types";

import { ACCOUNT_THEME_FRAGMENT, AccountThemeFragment } from "./accountTheme";
import { ADDRESS_FRAGMENT, AddressFragment } from "./address";
import { ATTACHMENT_FRAGMENT, AttachmentFragment } from "./attachment";
import { IDENTITY_FRAGMENT, IdentityFragment } from "./identity";

export const ACCOUNT_FRAGMENT = gql`
  fragment AccountFragment on Account {
    id
    slug
    identities {
      ...IdentityFragment
    }
    defaultIdentity {
      ...IdentityFragment
    }
    accountType
    industrySector
    email
    name
    description
    theme {
      ...AccountThemeFragment
    }
    logo {
      ...AttachmentFragment
    }
    symbol {
      ...AttachmentFragment
    }
    symbolDisplayPath
    hasFreelanceProfiles
    phoneNumber
    language
    address {
      ...AddressFragment
    }
    uiFlags {
      shownIds
    }
    organizationName
    organizationNumber
    nonProfit
    primaryUser {
      id
      firstName
      lastName
      confirmed
      email
    }
    role
    tag
    canManage
    counts {
      members
    }
    deletionScheduledOn
  }
  ${IDENTITY_FRAGMENT}
  ${ATTACHMENT_FRAGMENT}
  ${ACCOUNT_THEME_FRAGMENT}
  ${ADDRESS_FRAGMENT}
`;

interface AccountUiFlags extends Pick<UiFlags, "shownIds"> {
  shownIds: NoticeID[];
}

export interface AccountFragment
  extends Pick<
    Account,
    | "id"
    | "slug"
    | "accountType"
    | "industrySector"
    | "email"
    | "name"
    | "description"
    | "hasFreelanceProfiles"
    | "phoneNumber"
    | "language"
    | "symbolDisplayPath"
    | "organizationName"
    | "organizationNumber"
    | "nonProfit"
    | "primary"
    | "role"
    | "tag"
    | "canManage"
    | "deletionScheduledOn"
  > {
  identities?: IdentityFragment[];
  defaultIdentity?: IdentityFragment;
  symbol?: AttachmentFragment;
  logo?: AttachmentFragment;
  theme: AccountThemeFragment;
  address?: AddressFragment;
  uiFlags: AccountUiFlags;
  primaryUser?: Pick<
    User,
    "id" | "email" | "firstName" | "lastName" | "confirmed"
  >;
  counts?: Pick<Counts, "members">;
}
